 
 <input type="text" spellcheck="false"   class="form-control m-3" #answerInput name="answerInput" autofocus
 placeholder="Type In Your Answer" *ngIf="issaq" required    (change)="onAnswerChange()" (input)="onAnswerInputChange()" (keydown)="preventPipe($event)"/>